

export const get_cookie = (cookie_name) => {
    const results = document.cookie.match('(^|;) ?' + cookie_name + '=([^;]*)(;|$)');
    return results ? unescape(results[2]) : null;
};

export const formatDate = (timestamp) => {
    if (!timestamp) return 'Не обслуживался';
    const date = new Date(timestamp * 1000);
    return date.toLocaleDateString('ru-RU');
};

export const getServiceStatus = (timestamp) => {
    if (!timestamp) return 'default';
    const now = Date.now() / 1000;
    const diffDays = (now - timestamp) / (24 * 60 * 60);
    if (diffDays < 7) return 'success';
    if (diffDays < 30) return 'warning';
    return 'error';
};

// Функция для получения названия дня недели на русском
export const getRussianDayName = (date) => {
    const days = ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'];
    return days[date.getDay()];
};

// Функция для форматирования даты в русском формате
export const formatRussianDate = (date) => {
    return date.toLocaleDateString('ru-RU', {
        day: 'numeric',
        month: 'long'
    });
};

export const defaultComment = `• Проверка общего состояния растений и газона (цвет, листья, вредители).
• Сообщайте сразу, если растения или газон засохли или выглядят плохо.
• Удаление сорняков. 
• Обрезка сухих и отмерших частей растений. Удаление засохших растений.
• Проверка и полив растений в кашпо (если нет капельного полива).
• Покос газона.
• Проверка работы системы полива.
• Формирующая подрезка кустов и изгородей по необходимости. 
• Добавление почвы или мульчи в кашпо при необходимости.
• Подкормка удобрениями и поддержка стимуляторами при необходимости.`;